import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import {
  MarketplaceAdditionalArgs,
  MarketplaceAssetType,
} from './getPopularMarketplaceAssets';

export type GetUsStrategicReserveAssets = MarketplaceAssetType;
export type GetUsStrategicReserveResponse = {
  getUsStrategicReserveAssets: DefaultApiResponse<
    GetUsStrategicReserveAssets[]
  >;
};
type GetUsStrategicReserveAssetsArgs = MarketplaceAdditionalArgs;

export const getUsStrategicReserveAssetsQuery: TypedDocumentNode<
  GetUsStrategicReserveResponse,
  DefaultArg & GetUsStrategicReserveAssetsArgs
> = gql`
  query GetUsStrategicReserveAssets(
    $rateRecord: AssetsRateChangeRecord!
    $changeRecord: AssetsRateChangeRecord!
  ) {
    getUsStrategicReserveAssets {
      code
      iconUrl
      isFavorite
      name
      rate(record: $rateRecord)
      change(record: $changeRecord)
    }
  }
`;
